import {Component, Input} from '@angular/core';

@Component({
    selector: 'card-header',
    templateUrl: './card-header.component.html',
    standalone: false
})
export class CardHeaderComponent {
  @Input() title: string;
}
